import React from 'react';
import SelecterItem from './item';

type SelecterCheckboxProps = {
    data: any[];
    dataKey: string;
    dataValue: string;
    limit?: number;
    value?: any;
    onChange?: (val: any) => void;
} & Props;

const SelecterCheckbox: React.FC<SelecterCheckboxProps> = (props: SelecterCheckboxProps) => {
    const { value, data, dataKey, dataValue, limit } = props;

    const handleToggleOption = option => {
        let newValue = value || [];
        let idx = newValue.findIndex(item => item[dataKey] == option[dataKey]);
        if (~idx) {
            newValue.splice(idx, 1);
        } else {
            // if (limit && newValue.length >= limit) {
            //     return Toast.info(`仅可选择${limit}个`, 'none', 1500, true);
            // }
            newValue.push(option);
        }
        props.onChange && props.onChange([...newValue]);
    };

    return (
        <div className={`selecter-checkbox-list ${props.className}`}>
            {data.map((option, index) => (
                <SelecterItem
                    key={option[dataKey]}
                    active={!!value && !!~value.findIndex(item => item[dataKey] == option[dataKey])}
                    onClick={() => handleToggleOption(option)}
                >
                    {option[dataValue]}
                </SelecterItem>
            ))}
        </div>
    );
};

SelecterCheckbox.defaultProps = {
    data: [],
    dataKey: 'seq',
    dataValue: 'content',
    onChange: val => {},
};

export default SelecterCheckbox;
